import { Observable } from 'rxjs/Observable'

import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../../model-repository/model-repository'

import { Question } from '../../models'
import { AnswerChoiceGroupService, ExplanationService, QuestionPromptService } from '../'

export class QuestionService extends ModelRepositoryAdapter<Question> {
  public constructor(
    modelRepository: ModelRepository,
    private _answerChoiceGroupService: AnswerChoiceGroupService,
    private _explanationService: ExplanationService,
    private _questionPromptService: QuestionPromptService
  ) {
    super(modelRepository, Question)
  }

  public getQuestionWithRelationships(questionId: string): Observable<Question> {
    return this.findModelById(
      questionId,
      [
       'questionType.displayType',
       'questionPrompts.question',
       'explanations.explanationType',
       'answerChoiceGroups.answerChoices',
       'answerChoiceGroups.labels',
       'majorTopic.category',
       'minorTopics',
       'questionContext.questionContextType',
       'questionMetadatum'
     ]
    )
  }

  public save(question: Question): Observable<Question> {
    return super.save(question)
    .map((savedQuestion) => {
      return Observable.forkJoin(
        ...question.answerChoiceGroups.map((answerChoiceGroup) => {
          answerChoiceGroup.question = savedQuestion
          return this._answerChoiceGroupService.save(answerChoiceGroup)
        }),
        ...question.questionPrompts.map((questionPrompt) => {
          questionPrompt.question = savedQuestion
          return this._questionPromptService.save(questionPrompt)
        }),
        ...question.explanations.map((explanation) => {
          explanation.question = savedQuestion
          return this._explanationService.save(explanation)
        })
      ).map(() => savedQuestion)
    }).flatMap((savedQuestion) => savedQuestion)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/question/question.service.ts